module.exports = __webpack_public_path__ + "static/media/grape.ff6e4a73.jpg";